import Form   from '../../../../../../../display/forms/FormElements'
import Method from '../../../../../../../net/Method'

const elements =
[
    {
        type : Form.I18N_EDITOR ,
        init :
        {
            id    : 'description',
            key   : 'description',
            input : false,
            label : 'Description'
        }
    }
];

const risk =
{
    edit :
    {
        agree       : 'Sauver' ,
        disagree    : 'Annuler' ,
        fail        : 'Veuillez corriger les erreurs' ,
        loading     : 'Chargement en cours...' ,
        method      : Method.PATCH,
        mock        : false ,
        success     : 'Mise à jour réussie!' ,
        title       : 'Facteurs de risques' ,
        elements
    },
    labels:
    {
        description : 'Description'
    },
    title    : 'Facteurs de risques' ,
    tooltips :
    {
        edit : 'Modifier'
    }
};

export default risk ;